import {compose} from 'redux'

import withInteractiveUsers from 'containers/withInteractiveUsers'
import Pager from 'ipmp-react-ui/Pager'

export default compose(
    withInteractiveUsers(),
)(Pager)